<div class="row" *ngIf="(refNum | json) != '{}'">
    <div class="col-sm-12">
        <div class="row">
            <div class="col-sm-3">
                <label class="font-weight-bold">Reference Type</label>
            </div>
            <div class="col-sm-9">
                <select name="referenceType" [(ngModel)]="refNum.referenceTypeID" class="form-select" required>
                    <option *ngFor="let refType of referenceTypeList" value="{{refType.referenceTypeID}}">{{refType.referenceName}} - {{refType.referenceDescription}}</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <label class="font-weight-bold">Reference #</label>
            </div>
            <div class="col-sm-9">
                <input type="text" class="form-control" [(ngModel)]="refNum.value" required />
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12 m-2">
            <button class="btn btn-primary m-2" (click)="save()">Save</button>
            <button class="btn btn-secondary m-2" (click)="cancel()">Cancel</button>
        </div>
    </div>
</div>

<div class="spinner_container dark-overlay" [ngClass]="{'dark-overlay': isLoading}">
    <mat-spinner style="left: 50%; top: 50%" *ngIf="isLoading"></mat-spinner>
</div>